"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VerticalNav = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _VerticalNavItem = require("../VerticalNavItem/VerticalNavItem");
var _VerticalNavList = require("../VerticalNavList/VerticalNavList");
var _VerticalNav = require("./VerticalNav.styles");
var _excluded = ["navElevation", "elevation"];
/**
 * @subcomponents ['VerticalNav.List', 'VerticalNav.Item']
 * @since 8.72.0
 */

var VerticalNav = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, forwardedRef) {
  var navElevation = _ref.navElevation,
    elevation = _ref.elevation,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var isElevationBool = typeof elevation === 'boolean';
  var props = Object.assign({}, rest, {
    navElevation: navElevation && isElevationBool ? elevation : navElevation
  });
  return /*#__PURE__*/_react.default.createElement(_VerticalNav.StyledVerticalNav, (0, _extends2.default)({
    ref: forwardedRef
  }, props));
});
exports.VerticalNav = VerticalNav;
VerticalNav.displayName = 'VerticalNav';
VerticalNav.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * This prop if true adds a border
   */
  border: _propTypes.default.bool,
  /**
   * This prop if true adds a background color, false will be transparent
   */
  background: _propTypes.default.bool,
  /**
   * A group of `VerticalNav.List` components.
   */
  children: _propTypes.default.node.isRequired,
  /**
   * This prop if true adds a dropshadow. Use this in favor of `elevation`
   * which will be deprecated.
   */
  navElevation: _propTypes.default.bool,
  /**
   * @deprecated We are deprecating the use of elevation because it is a reserved HTML
   * attribute for SVG's [`feDistantLight`](https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/elevation).
   * Please use `navElevation` instead.
   *
   * This prop if true adds a dropshadow
   */
  elevation: _propTypes.default.bool,
  /**
   * Use the styled-components
   * [polymorphic "as" prop](https://www.styled-components.com/docs/api#as-polymorphic-prop)
   * to change the HTML tag of the component.
   *
   * This can be used to apply `Button` styling to HTML anchors, inputs, and custom components.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  as: _propTypes.default.any
} : {};
VerticalNav.defaultProps = {
  border: true,
  background: true,
  navElevation: true
};
VerticalNav.List = _VerticalNavList.VerticalNavList;
VerticalNav.Item = _VerticalNavItem.VerticalNavItem;